import { CbhFeatureFlag, FEATURE_FLAG_DEFAULT_VALUES, useCbhFlag } from "@src/appV2/FeatureFlags";

export function useSupportLinks() {
  const links = useCbhFlag(CbhFeatureFlag.SUPPORT_LINKS, {
    defaultValue: FEATURE_FLAG_DEFAULT_VALUES[CbhFeatureFlag.SUPPORT_LINKS],
  });
  return {
    howToContactSupportLink: links.HOW_TO_CONTACT_SUPPORT,
    whySsnSupportLink: links.WHY_SSN,
    helpCenterWorkerSupportLink: links.HELP_CENTER_WORKER,
    backgroundChecksSupportLink: links.BACKGROUND_CHECKS,
    timesheetSignaturesSupportLink: links.TIMESHEET_SIGNATURES,
    attendanceScoreSupportLink: links.ATTENDANCE_SCORE,
    dnrRequestsWorkerSupportLink: links.DNR_REQUESTS_WORKER,
    multiStateLicensesSupportLink: links.MULTI_STATE_LICENSES,
    workWithFriendsSupportLink: links.WORK_WITH_FRIENDS,
    rateNegotiationWorkerSupportLink: links.RATE_NEGOTIATION_WORKER,
    referralBonusSupportLink: links.REFERRAL_BONUS,
    suspensionAndDeactivationRulesSupportLink: links.SUSPENSION_AND_DEACTIVATION_RULES,
    instantPayInfoSupportLink: links.INSTANT_PAY_INFO,
    extraWorkBreaksSupportLink: links.EXTRA_WORK_BREAKS,
    editingClockInAndOutTimesSupportLink: links.EDITING_CLOCK_IN_AND_OUT_TIMES,
    clockingInWithNfcTagsSupportLink: links.CLOCKING_IN_WITH_NFC_TAGS,
    dynamicPenaltiesSupportLink: links.DYNAMIC_PENALTIES,
    priorityAccessSupportLink: links.PRIORITY_ACCESS,
    breakPaymentRequestsSupportLink: links.BREAK_PAYMENT_REQUESTS,
    paperTimesheetInstructionsSupportLink: links.PAPER_TIMESHEET_INSTRUCTIONS,
    shiftBlocksSupportLink: links.SHIFT_BLOCKS,
    skillsAssessmentConfigSupportLink: links.SKILLS_ASSESSMENT_CONFIG,
    referralShiftAttendanceRateSupportLink: links.REFERRAL_SHIFT_ATTENDANCE_RATE,
    affiliateGuideSupportLink: links.AFFILIATE_GUIDE,
    referralGuideSupportLink: links.REFERRAL_GUIDE,
    referralPolicySupportLink: links.REFERRAL_POLICY,
    whyWorkersSeeQuizSupportLink: links.WHY_WORKERS_SEE_QUIZ,
    clipboardScoreSupportLink: links.CLIPBOARD_SCORE,
    limitedStatusSupportLink: links.LIMITED_STATUS,
    inHomeFaqSupportLink: links.IN_HOME_FAQ,
    inHomeDemoSupportLink: links.IN_HOME_DEMO,
    placementClaimSignOnBonusSupportLink: links.PLACEMENT_CLAIM_SIGN_ON_BONUS,
    placementInterviewAttendancePolicySupportLink: links.PLACEMENT_INTERVIEW_ATTENDANCE_POLICY,
    placementInterviewAttendanceSimplifiedPolicySupportLink:
      links.PLACEMENT_INTERVIEW_ATTENDANCE_SIMPLIFIED_POLICY,
    workerReferralProgramSupportLink: links.WORKER_REFERRAL_PROGRAM,
    signIcAgreementSupportLink: links.SIGN_IC_AGREEMENT,
    renewCnaLicenseSupportLink: links.RENEW_CNA_LICENSE,
    inviteRequiredSupportLink: links.INVITE_REQUIRED,
  };
}
